import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=081e6bcc"
import script from "./PartnerList.vue?vue&type=script&lang=ts"
export * from "./PartnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports